module.exports = __webpack_public_path__ + "assets/img/success-2.12f7e80c.svg";